export const appendFormMessage = (prev: string | undefined, next: string) => {
  return prev ? `${prev} || ${next}` : next;
};
